import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@material-ui/core";
import { Close, VisibilityOutlined } from "@material-ui/icons";
import useStyles from "./styles";

export default function AnnouncementPreview({ record, onClose }) {
  const classes = useStyles();
  return <Dialog open onClose={onClose} fullWidth maxWidth="sm" classes={{ paper: classes.dialog }} aria-labelledby="announcement-preview-title">
    <DialogTitle className={classes.dialogTitle} id="announcement-preview-title"><VisibilityOutlined />Visualizar informativo<IconButton className={classes.close} aria-label="Fechar visualização" onClick={onClose}><Close /></IconButton></DialogTitle>
    <DialogContent className={classes.content}>
      <div className={classes.previewMeta}><span className={`${classes.priority} ${classes[`priority${record.priority}`] || ""}`}>Prioridade {({ 1: "alta", 2: "média", 3: "baixa" })[record.priority]}</span><span className={`${classes.status} ${record.status ? classes.active : ""}`}>{record.status ? "Ativo" : "Inativo"}</span></div>
      <Typography component="h2" className={classes.previewTitle}>{record.title}</Typography>
      {record.mediaPath && <img src={record.mediaPath} alt={record.mediaName || "Imagem do informativo"} className={classes.image} />}
      <Typography className={classes.previewText}>{record.text}</Typography>
    </DialogContent>
    <DialogActions className={classes.dialogActions}><Button variant="outlined" onClick={onClose}>Fechar</Button></DialogActions>
  </Dialog>;
}
